class ContentImageWithCaption {
  constructor(contentfulNode) {
    this.caption = contentfulNode?.caption;
    this.captionAlignment = contentfulNode?.captionAlignment;
    this.linkText = contentfulNode?.linkText;
    this.linkUrl = contentfulNode?.linkUrl;
    this.image = contentfulNode?.image;
    this.type = 'CONTENT_IMAGE_WITH_CAPTION';
  }
}

export { ContentImageWithCaption };
